import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
  Grid,
  Checkbox,
  TableCell,
  TableRow,
} from "@material-ui/core";
import moment from "moment";
import {
  Toast,
  SimpleToolbar,
  AssignProduct,
  Loader,
  ConfirmationModal,
  Drawer,
  BaseTable,
  StyledTableCell,
  StyledTableRow,
} from "../components";
import { AuthContext } from "../context";
import { productsServices } from "../services";
import { useDrawer } from "../hooks";

export default function AssignmentsScreen(props) {
  const classes = useStyles();
  const { authState, signOut } = useContext(AuthContext);
  const [productsAssigned, setProductsAssigned] = useState([]);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [openModalAsign, setOpenModalAsign] = useState(false);
  const [reload, setReload] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const { isOpen, setIsOpen } = useDrawer();
  const [tableHeader, setTableHeader] = useState([]);
  const [tableBody, setTableBody] = useState([]);

  useEffect(() => {
    setTableHeader([
      "Unidad de negocio",
      "RUT",
      "Doctor",
      "Producto",
      "Cantidad",
      "Presentación",
      "Concentración",
      "Estado",
      "Asignación",
    ]);

    const tableData = productsAssigned.map((assignedProduct) => {
      return {
        "Unidad de negocio": assignedProduct?.laboratory?.name || "",
        RUT: assignedProduct?.doctor?.rut || "",
        Doctor: `${assignedProduct?.doctor?.name || ""} ${
          assignedProduct?.doctor?.lastName || ""
        }`,
        Producto: assignedProduct?.product?.name || "",
        Cantidad: assignedProduct?.assigned || "",
        Presentación: assignedProduct?.product?.presentation || "",
        Concentración: assignedProduct?.product?.concentration || "",
        Estado: assignedProduct?.product?.isExpire ? "Vencido" : "Vigente",
        Asignación:
          moment(assignedProduct?.createdAt).format("DD/MM/YYYY") || "",
      };
    });
    setTableBody(tableData);
  }, [productsAssigned]);

  const getProductsAssigned = async ({ page, limit, authState, text }) => {
    try {
      setLoading(true);
      const { status, response } = await productsServices.getProductsAssigned({
        laboratoryId: authState.user.laboratory._id,
        page,
        limit,
        token: authState.token,
        text,
      });
      setLoading(false);
      //console.log({status, response})
      if (status === 200) {
        setProductsAssigned(response.products);
        setCount(response.total);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    setReload(false);
    getProductsAssigned({ page, limit, authState, text: "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, authState, reload]);

  const getProductsAssignedFilter = async (text) => {
    getProductsAssigned({ page, limit, authState, text });
  };

  const onDelete = async () => {
    try {
      const { status, response } =
        await productsServices.deleteProductsAssignmet({
          array: selectedProductIds,
          token: authState.token,
        });
      if (status === 200) {
        setToastMessage(response.message);
        setSelectedProductIds([]);
        setToast(true);
        setReload(true);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      console.log(e);
    }
  };

  /*const handleSelectAll = (event) => {
    let newSelectedProductIds;

    if (event.target.checked) {
      newSelectedProductIds = productsAssigned.map((product) => product._id);
    } else {
      newSelectedProductIds = [];
    }

    setSelectedProductIds(newSelectedProductIds);
  };*/

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedProductIds.indexOf(id);
    let newSelectedProductIds = [];

    if (selectedIndex === -1) {
      newSelectedProductIds = newSelectedProductIds.concat(
        selectedProductIds,
        id
      );
    } else if (selectedIndex === 0) {
      newSelectedProductIds = newSelectedProductIds.concat(
        selectedProductIds.slice(1)
      );
    } else if (selectedIndex === selectedProductIds.length - 1) {
      newSelectedProductIds = newSelectedProductIds.concat(
        selectedProductIds.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedProductIds = newSelectedProductIds.concat(
        selectedProductIds.slice(0, selectedIndex),
        selectedProductIds.slice(selectedIndex + 1)
      );
    }

    setSelectedProductIds(newSelectedProductIds);
  };

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        <Toast
          message={toastMessage}
          open={toast}
          close={() => setToast(false)}
        />
        <ConfirmationModal
          open={openAlert}
          setOpenAlert={setOpenAlert}
          setConfirmAction={() => onDelete()}
        />
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            {openModalAsign && (
              <AssignProduct
                reload={() => setReload(true)}
                open={openModalAsign}
                close={() => setOpenModalAsign(false)}
              />
            )}
            <Container maxWidth={false}>
              <SimpleToolbar
                addButton
                labelAddButton={"Asignar"}
                deleteButton
                disabledDetele={!selectedProductIds.length}
                onDelete={() => setOpenAlert(true)}
                onAdd={() => setOpenModalAsign(true)}
                onFilter={(text) => getProductsAssignedFilter(text)}
                table={"assignmentTable"}
                filename={"Asignaciones a doctores"}
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                tableHeader={tableHeader}
                tableBody={tableBody}
              />
              <BaseTable>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>Seleccionar</StyledTableCell>
                    {authState.user.role.name === "LABORATORY_ADMIN" && (
                      <StyledTableCell>Unidad de negocio</StyledTableCell>
                    )}
                    <StyledTableCell>RUT</StyledTableCell>
                    <StyledTableCell>Doctor</StyledTableCell>
                    <StyledTableCell>Producto</StyledTableCell>
                    <StyledTableCell>Cantidad</StyledTableCell>
                    <StyledTableCell>Presentación</StyledTableCell>
                    <StyledTableCell>Concentración</StyledTableCell>
                    <StyledTableCell>Estado</StyledTableCell>
                    <StyledTableCell>Asignación</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {productsAssigned.map((productAssigned, index) => (
                    <StyledTableRow hover key={productAssigned._id}>
                      <StyledTableCell>
                        <Checkbox
                          checked={
                            selectedProductIds.indexOf(productAssigned._id) !==
                            -1
                          }
                          onChange={(event) =>
                            handleSelectOne(event, productAssigned._id)
                          }
                          value="true"
                        />
                      </StyledTableCell>
                      {authState.user.role.name === "LABORATORY_ADMIN" && (
                        <StyledTableCell
                          style={{
                            color: index % 2 === 0 ? "#192A7F" : "#2196C0",
                          }}
                        >
                          {productAssigned.laboratory.name}
                        </StyledTableCell>
                      )}
                      <StyledTableCell>
                        {productAssigned.doctor.rut.charAt(
                          productAssigned.doctor.rut.length - 2
                        ) === "-"
                          ? productAssigned.doctor.rut
                          : `${productAssigned.doctor.rut.slice(
                              0,
                              productAssigned.doctor.rut.length - 1
                            )}-${productAssigned.doctor.rut.slice(
                              productAssigned.doctor.rut.length - 1
                            )}`}
                      </StyledTableCell>
                      <StyledTableCell>{`${productAssigned.doctor.name} ${productAssigned.doctor.lastName}`}</StyledTableCell>
                      <StyledTableCell>
                        {productAssigned.product.name}
                      </StyledTableCell>
                      <StyledTableCell>
                        {productAssigned.assigned}
                      </StyledTableCell>
                      <StyledTableCell>
                        {productAssigned.product.presentation}
                      </StyledTableCell>
                      <StyledTableCell>
                        {productAssigned.product.concentration}
                      </StyledTableCell>
                      <StyledTableCell>
                        {productAssigned.product.isExpire
                          ? "Vencido"
                          : "Vigente"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {moment(productAssigned.createdAt).format("DD/MM/YYYY")}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => setLimit(e.target.value)}
                onChangePage={(e, page) => setPage(page + 1)}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>

      <div style={{ display: "none" }}>
        <BaseTable tableId="assignmentTable">
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>Rut</StyledTableCell>
              <StyledTableCell>Doctor</StyledTableCell>
              <StyledTableCell>Producto</StyledTableCell>
              <StyledTableCell>Cantidad</StyledTableCell>
              <StyledTableCell>Presentacion</StyledTableCell>
              <StyledTableCell>Concentracion</StyledTableCell>
              <StyledTableCell>Estado</StyledTableCell>
              <StyledTableCell>Asignacion</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {productsAssigned.map((productAssigned, index) => {
              // console.log(productAssigned);

              const {
                _id,
                rut,
                firstName,
                lastName,
                email,
                phone,
                status,
                address,
                createdAt,
                updatedAt,
                doctor,
                products,
              } = productAssigned;

              return (
                <TableRow>
                  <TableCell>
                    {productAssigned.doctor.rut.charAt(
                      productAssigned.doctor.rut.length - 2
                    ) === "-"
                      ? productAssigned.doctor.rut
                      : `${productAssigned.doctor.rut.slice(
                          0,
                          productAssigned.doctor.rut.length - 1
                        )}-${productAssigned.doctor.rut.slice(
                          productAssigned.doctor.rut.length - 1
                        )}`}
                  </TableCell>
                  <TableCell>{`${productAssigned.doctor.name} ${productAssigned.doctor.lastName}`}</TableCell>
                  <TableCell> {productAssigned.product.name}</TableCell>
                  <TableCell> {productAssigned.assigned}</TableCell>
                  <TableCell> {productAssigned.product.presentation}</TableCell>
                  <TableCell>{productAssigned.product.concentration}</TableCell>
                  <TableCell>
                    {productAssigned.product.isExpire ? "Vencido" : "Vigente"}
                  </TableCell>
                  <TableCell>
                    {moment(productAssigned.createdAt).format("DD/MM/YYYY")}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </BaseTable>
        1
      </div>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
}));
